import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class NetworkStatusService {

    private onlineStatusSubject: BehaviorSubject<boolean>;

    constructor() {
        this.onlineStatusSubject = new BehaviorSubject<boolean>(navigator.onLine);

        const online$: Observable<boolean> = fromEvent(window, 'online').pipe(map(() => true));
        const offline$: Observable<boolean> = fromEvent(window, 'offline').pipe(map(() => false));

        merge(online$, offline$).subscribe(isOnline => {
            this.onlineStatusSubject.next(isOnline);
        });
    }

    public get statusChanges$(): Observable<boolean> {
        return this.isOnline$();
    }

    public isOnline$(): Observable<boolean> {
        return this.onlineStatusSubject.asObservable();
    }

    public isOnline(): boolean {
        return this.onlineStatusSubject.getValue();
    }
}
